import React, { Fragment } from 'react';
import _ from 'lodash'
import Select from 'react-select'
import CreatableSelect from 'react-select/lib/Creatable'
import {
  Col,
  FormInputText,
  Row,
  FormInput,
  FormInputCheckbox,
  Tip
} from 'camino-react'

import { cloudhelpGet, cloudhelpPatch } from 'Utilities/CloudHelp'
import { csrfToken } from 'Utilities/Csrf'

import Alert from 'Components/Alert'
import ErrorList from 'Components/ErrorList'
import UserCreateForm from 'Components/Users/Create/Form'

export default class ClientFormFields extends React.Component {
  constructor (props) {
    super(props)

    const { ticket } = props
    this.setParentState = props.setParentState

    this.state = {
      ticket,
      clients: [],
      client_contacts: [],
      users: [],
      showSecondaryContactField: !!ticket.secondary_contact_email,
      errors: [],
      clientContactLoading: false,
      creatingContact: false,
      loadingClients: false,
      secondaryContactEmail: { label: ticket.secondary_contact_email, value: ticket.secondary_contact_email },
      disabledContactNotifications: ticket.disabledContactNotifications
    }
  }

  componentDidMount () {
    this.getClients()
  }

  getClients = () => {
    const { current_user: currentUser, client_id } = this.props

    if (_.isNil(currentUser.id)) { return }

    cloudhelpGet(`/api/clients`)
      .then((response) => {
        const clients = _.map(response.data, client => ({ value: client.id, label: client.short_name }))

        this.setState({
          clients: _.sortBy(clients, client => (client.label)),
          loadingClients: false
        })
      })
      .catch(() => {
        this.setParentState({ loadingClients: false })
      })

    cloudhelpGet(`/api/clients/${client_id}/users`)
      .then((response) => {
        const { data } = response
        const client_contacts = _.map(data, (user) => {
          return {
            value: user.id,
            label: user.name,
            email: user.email,
            contact_number: user.contact_number
          }
        })

        const clientsUsersEmailsOptions = _.isNil(client_contacts) ? [] : _.map(client_contacts, user => ({ value: user.email, label: user.email }))

        this.setState({
          users: data,
          client_contacts,
          clientsUsersEmailsOptions,
          loadingClients: false
        })
      })
      .catch(() => {
        this.setState({ loadingClients: false })
      })
  }

  handleSelectChange = (fieldName, selectedOption) => {
    const option = selectedOption || {}

    this.setParentState({ [fieldName]: option.value })
  }

  handleClientSelectChange = (selectedOption) => {
    this.setParentState({
      client_id: selectedOption.value,
      client_name: selectedOption.label,
      client_contact_id: null,
      primary_contact_email: '',
      contact_number: '',
      client_contact_name: ''
    })

    cloudhelpGet(`/api/clients/${selectedOption.value}/users`)
      .then((response) => {
        const { data } = response
        const client_contacts = _.map(data, (user) => {
          return {
            value: user.id,
            label: user.name,
            email: user.email,
            contact_number: user.contact_number
          }
        })

        this.setState({
          users: data,
          client_contacts,
          loadingClients: false
        })
      })
      .catch(() => this.setState({ loadingClients: false }))
  }

  handleClientContactSelectChange = (selectedOption) => {
    const { client_contacts } = this.state
    const clientContact = _.find(client_contacts, u => (u.value === selectedOption.value))

    this.handleSelectChange('client_contact_id', selectedOption)
    this.handleSelectChange('primary_contact_name', { value: selectedOption.label })
    if (clientContact) {
      this.handleSelectChange('primary_contact_email', { value: clientContact.email })
      if (clientContact.contact_number) {
        this.handleSelectChange('contact_number', { value: clientContact.contact_number })
      }
    }
  }

  showEditModal (event) {
    event.preventDefault()

    this.setParentState({ showEditModal: true })
  }

  setFieldErrorClasses (field) {
    const { fieldsWithErrors } = this.state

    if (_.includes(fieldsWithErrors, field)) {
      return ('error')
    }
  }

  toggleSecondaryContactField (event) {
    event.preventDefault()
    const { showSecondaryContactField } = this.state

    this.setState({
      showSecondaryContactField: !showSecondaryContactField
    })
  }

  removeSecondaryContactField (event) {
    event.preventDefault()
    const { showSecondaryContactField } = this.state

    this.setParentState({ secondary_contact_email: '' })
    this.setState({ showSecondaryContactField: !showSecondaryContactField })
  }

  setFieldErrorClasses = (field) => {
    if (_.includes(this.state.fieldsWithErrors, field)) {
      return ('error')
    }
  }

  hasRole = (...args) => {
    const { roles } = this.props

    return _.get(roles, args)
  }

  setSecondaryContactEmail = (value) => {
    this.setParentState({ secondaryContactEmail: value })
  }

  render() {
    const {
      service_category_id,
      sub_category_id,
      customer_contract_id,
      service_id,
      service_type,
      primary_contact_email,
      client_id,
      current_user,
      clientPath,
      ticket_types
    } = this.props

    const {
      secondary_contact_email,
      preferredContactMethod,
      primary_contact_numbers,
      lifecycleStatus,
      twentyHourSupport,
      client_id: originalClientId
    } = this.props.ticket

    const { setFieldErrorClasses, handleSelectChange, setParentState } = this

    const {
      ticket,
      showEditModal,
      clientIsManaged,
      contact_number,
      client_contact,
      client_contact_path,
      client,
      clients,
      creatingContact,
      clientContactLoading,
      loadingClients,
      clientsUsersEmailsOptions,
      secondaryContactEmail,
      disabledContactNotifications
    } = this.state

    const addContactButtonStyles = {
      display: 'flex',
      border: '1px solid #c0e2ff',
      borderTopRightRadius: '5px',
      borderBottomRightRadius: '5px',
      height: '36px',
      alignItems: 'center',
      justifyContent: 'center',
      fontSize: '18px',
      cursor: 'pointer'
    }

    const allowedContactMethods = client_contact && _({ Phone: client_contact.allow_phone, Email: client_contact.allow_email }).pickBy(v => v).keys().join(' or ')
    const contactMethod = preferredContactMethod || allowedContactMethods
    const phoneNumber = (phoneNumbers) => {
      if (_.isEmpty(phoneNumbers)) {
        return 'Not provided'
      }

      return _.map(phoneNumbers, phone => (
        <p>
          {`${_.capitalize(phone.phone_type.replace('telephone', '').replace('_', ''))} ${phone.number}`}
        </p>
      ))
    }

    if (creatingContact) {
      return (
        <UserCreateForm
          clientId={client_id}
          afterSave={(response) => {
            const user = response.data.user

            this.setState(prevState => ({
              creatingContact: false,
              client_contacts: _.concat(prevState.client_contacts, { value: user.id, label: user.name, email: user.email, contact_number: user.phone_number })
            }))

            setParentState({
              primary_contact_email: user.email,
              primary_contact_name: user.name,
              client_contact_id: user.id,
            })
          }}
          groupsOptions={[
            { label: 'User', value: 9 },
            { label: 'Client Admin', value: 10 },
            { label: 'Partner Admin', value: 11 },
          ]}
          onCancel={() => { setCreatingContact(false); setParentState({ creatingContactForClient: false })}}
        />
      )
    }

    return (
      <Fragment>
        <div className="row row--small-gutters">
          <div className="col-12">
            <label htmlFor="ticket_primary_contact_email">
              Contact Email
              <FormInputText
                value={this.props.primary_contact_email}
                name="primary_contact_email"
                id="ticket_primary_contact_email"
                type="text"
                className={this.setFieldErrorClasses('primary_contact_email')}
                onValue={text => this.setParentState({ primary_contact_email: text })}
              />
            </label>
          </div>

          <div className="col-12">
            <label htmlFor="ticket_contact_number">
              Contact Number
              <FormInputText
                value={this.props.contact_number}
                name="contact_number"
                id="ticket_contact_number"
                className={this.setFieldErrorClasses('contact_number')}
                onValue={text => this.setParentState({ contact_number: text })}
              />
            </label>
          </div>
        </div>

        <div className="row row--small-gutters mt-3">
          <div className="col-12">
            <label htmlFor="client_id">
              Client
              <Select
                id="ticket_client_id"
                className={this.setFieldErrorClasses('client_id')}
                name="ticket[client_id]"
                value={this.props.client_id}
                onChange={option => (this.handleClientSelectChange(option))}
                options={this.state.clients}
                isLoading={loadingClients}
                clearable={false}
              />
            </label>

            <div className="mb-3 -mt-3 flex items-center">
              <FormInputCheckbox
                id='disabledContactNotifications'
                value={this.props.disabledContactNotifications}
                onValue={value => this.setParentState({ disabledContactNotifications: value })}
              >
                <span className="mr-2">
                  Disable client notifications for this ticket
                </span>
              </FormInputCheckbox>

              <Tip content="Select this checkbox if you don't want
                to send any email to the customer contact"
              />
            </div>
          </div>

          <div className="col-12">
            <label htmlFor="ticket_client_contact_id">
              Client Contact
            </label>
            {(_.isEmpty(this.state.client_contacts) && !_.isNil(this.props.client_id) && this.state.clients) ? (
              <p>
                There are no users for this client.
              </p>
            ) : (
                <Row noGutters>
                  <Col width={loadingClients ? 24 : 23}>
                    <Select
                      id="ticket_client_contact_id"
                      className={this.setFieldErrorClasses('client_contact_id')}
                      name="ticket[client_contact_id]"
                      value={this.props.client_contact_id}
                      onChange={option => (this.handleClientContactSelectChange(option))}
                      options={this.state.client_contacts}
                      isLoading={loadingClients}
                      clearable={false}
                    />
                  </Col>
                  {!loadingClients && <Col width={1}>
                    <i
                      className='lnr lnr-plus'
                      style={addContactButtonStyles}
                      onClick={() => this.setState({ creatingContact: true })}
                    >
                    </i>
                  </Col>}
                </Row>
              )
            }
          </div>
        </div>

        <div style={{ display: this.state.showSecondaryContactField ? 'block' : 'none' }}>
          <FormInput label="Secondary Contact Email">
            <CreatableSelect
              disabled={_.isEmpty(clients)}
              options={clientsUsersEmailsOptions}
              value={_.isEmpty(clients) ? null : this.props.secondaryContactEmail}
              onChange={(value) => {
                const secondary_contact_email = (value) ? value.value : null;
                this.setParentState({ secondary_contact_email: secondary_contact_email, secondaryContactEmail: value })
              }}
            />
          </FormInput>
        </div>

        {!this.state.showSecondaryContactField && (
          <a onClick={(event) => { this.toggleSecondaryContactField(event) }} href="#" className="link link--decorated">
            <span className="lnr lnr-plus lnr-inline lnr-black lnr-small" />
            {' '}
            Add Secondary Contact
          </a>
        )}
        {this.state.showSecondaryContactField && (
          <a onClick={(event) => { this.removeSecondaryContactField(event) }} href="#" className="link link--decorated">
            <span className="lnr lnr-minus lnr-inline lnr-black lnr-small" />
            {' '}
            Remove Secondary Contact
          </a>
        )}
      </Fragment>
    )
  }
}
